import { render, staticRenderFns } from "./PrepaidBlock.vue?vue&type=template&id=90838838"
import script from "./PrepaidBlock.vue?vue&type=script&lang=js"
export * from "./PrepaidBlock.vue?vue&type=script&lang=js"
import style0 from "./PrepaidBlock.vue?vue&type=style&index=0&id=90838838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports